module.exports = __webpack_public_path__ + "media/images/lb/545-81374b635f92fb83077f827ea9620902.svg";